import curry from "../../../lib/core/functional/curry";
import noop from "../../../lib/core/functional/noop";

const renderModule = curry(function renderModule(preact, _context, _deps, _altLoader) {
    const { hooks, h } = preact;
    const { useCallback, useState } = hooks;

    function Module(props) {
        const { logo, uploading, uploadData, onNewAvatarFile, onNewAvatarUrl, saveChanges } = props;
        const [displayEditor, setDisplayEditor] = useState(false);
        const [isHovering, setIsHovering] = useState(false);
        const [avatarUrl, setAvatarUrl] = useState("");

        const displayLogo = logo || "/res/avatars/default";
        const loadedLogo = uploadData ? uploadData.logo : logo;

        const showEditor = useCallback(function showEditor() {
            setDisplayEditor(true);
        }, []);

        const hideEditor = useCallback(function hideEditor(event) {
            event.stopPropagation();
            setDisplayEditor(false);
            return false;
        }, []);

        const onMouseEnter = useCallback(function onMouseEnter() {
            setIsHovering(true);
        }, []);

        const onMouseLeave = useCallback(function onMouseLeave() {
            setIsHovering(false);
        }, []);

        const onNewFile = useCallback(
            function onNewFile(event) {
                onNewAvatarFile(event.target.files[0]);
            },
            [onNewAvatarFile]
        );

        const onNewUrl = useCallback(
            function onNewUrl() {
                if (avatarUrl) {
                    onNewAvatarUrl(avatarUrl);
                }
            },
            [avatarUrl, onNewAvatarUrl]
        );

        const onUrlChange = useCallback(function onUrlChange(event) {
            setAvatarUrl(event.target.value);
        }, []);

        const commitChanges = useCallback(
            function commitChanges() {
                saveChanges(uploadData);
            },
            [saveChanges, uploadData]
        );

        return (
            <div
                class="community-site-logo"
                style={`background-image: url('${displayLogo}')`}
                onClick={showEditor}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <a
                    href="javascript:;"
                    class={`hover-menu edit start-edit${isHovering ? "" : " hidden"}`}
                    title="Edit"
                >
                    Edit
                </a>
                <div
                    class={`edit-mode ${displayEditor ? "community-site-logo-slide-in" : "hidden"}`}
                >
                    <div class="edit-mode-inner">
                        <div
                            class="community-site-logo logo-preview"
                            style={`background-image: url('${loadedLogo}');`}
                        ></div>
                        <div class="site-avatar">
                            <label>Change your avatar photo</label>
                            <form
                                class="avatar-form"
                                enctype="multipart/form-data"
                                encoding="multipart/form-data"
                                method="GET"
                                onSubmit={noop}
                            >
                                <div style="position:relative;">
                                    <label class="fake-input">
                                        <input
                                            id="fileInput"
                                            class="input-file"
                                            type="file"
                                            name="logo"
                                            disabled={uploading}
                                            onChange={onNewFile}
                                        />
                                    </label>
                                    <a class="ch-cover-upload btn" href="javascript: void(0)">
                                        <span>
                                            <i class="icons-roar upload-from-pc"></i> Upload
                                        </span>
                                    </a>
                                    <div
                                        class={`progress progress-striped animated-bar ${
                                            uploading ? "indeterminate-bar" : "hidden"
                                        }`}
                                    >
                                        <div style="width: 100%;" class="bar"></div>
                                        <span class="status-text"></span>
                                    </div>
                                </div>
                            </form>
                            <span class="or">or</span>
                            <div class="input-form">
                                <input
                                    class="image-by-url"
                                    type="text"
                                    placeholder="Paste URL to upload from web..."
                                    value={avatarUrl}
                                    onChange={onUrlChange}
                                />
                                <a
                                    href="javascript:;"
                                    class="btn add-image-by-src"
                                    onClick={onNewUrl}
                                >
                                    <i class="upload-arrow"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix buttons">
                        <a href="javascript:;" class="btn cancel cancel-btn" onClick={hideEditor}>
                            Cancel
                        </a>
                        <a
                            href="javascript:;"
                            class="btn save-site-logo-url"
                            disabled={uploadData == null}
                            onClick={commitChanges}
                        >
                            Save
                        </a>
                    </div>
                </div>
            </div>
        );
    }
    return Module;
});

export default function renderEditSitLogo({ preact }) {
    return renderModule(preact);
}
